export { default } from './pageLoader.component';
